import { lmsFetchAPI } from "../../../../utils/axios";

const REPORTS_PATH = "/lms/reports/weekly";

const toApiError = (error, fallback) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.error || fallback;
    return { status, message };
};

export const getWeeklyReport = async ({ studentId, weekStartDate } = {}) => {
    try {
        const params = {
            studentId,
            ...(weekStartDate ? { weekStartDate } : {}),
        };

        const response = await lmsFetchAPI.get(REPORTS_PATH, { params });
        return response.data;
    } catch (error) {
        throw toApiError(error, "Unable to load weekly report");
    }
};
